<table mat-table
    #assetTable
    [dataSource]="assets"
    *ngIf="assets.length > 0"
    >
    <ng-container matColumnDef="selected">
        <th mat-header-cell *matHeaderCellDef>
            @if(multiSelect){
                <span style="padding: 1px;">
                    <mat-checkbox (change)="selectAllAssets()" 
                        [(ngModel)]="allSelected"
                        color="accent"
                        style="color: white;"></mat-checkbox>
                </span>
            }
        </th>
        <td mat-cell *matCellDef="let e">
            <mat-checkbox [(ngModel)]="e.selected"
                    (change)="selectedAssetChanged(e.id, e.selected)"></mat-checkbox>
        </td>
    </ng-container>

    <ng-container matColumnDef="ref">
        <th mat-header-cell *matHeaderCellDef>Ref</th>
        <td mat-cell *matCellDef="let element">
            {{element.assetRef}}
        </td>
    </ng-container>

    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">
            {{element.assetName}}
        </td>
    </ng-container>

    <ng-container matColumnDef="acq">
        <th mat-header-cell *matHeaderCellDef>Acquired</th>
        <td mat-cell *matCellDef="let element">{{element.acquiredOn | companyDate: region}}</td>
    </ng-container>

    <ng-container matColumnDef="class">
        <th mat-header-cell *matHeaderCellDef>
            <span appCompanyDynFieldHeader [fieldName]="'class'"></span>
        </th>
        <td mat-cell *matCellDef="let element">{{element.class}}</td>
    </ng-container>

    <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef>
            <span appCompanyDynFieldHeader [fieldName]="'location'"></span>
        </th>
        <td mat-cell *matCellDef="let element">{{element.location}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns" class="row-head"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
</table>